import { File, FileText, Image, Video } from '../../icons';

/**
 * AttachmentTypeIcon (v2.8.4, 2026-06-11) — 첨부 파일을 타입별 컬러 아이콘 칩으로 표시.
 * mime 우선, 부재 시 확장자로 판정. 이미지=초록 / 영상=보라 / 문서(pdf·office·텍스트)=파랑 /
 * 압축=주황 / 그 외=회색 generic File.
 */
type Kind = 'image' | 'video' | 'doc' | 'archive' | 'etc';

const EXT_MAP: Record<string, Kind> = {
  png: 'image', jpg: 'image', jpeg: 'image', gif: 'image', webp: 'image', svg: 'image', bmp: 'image',
  mp4: 'video', mov: 'video', avi: 'video', webm: 'video', mkv: 'video',
  pdf: 'doc', doc: 'doc', docx: 'doc', xls: 'doc', xlsx: 'doc', ppt: 'doc', pptx: 'doc',
  // hwpx 는 MIME 이 application/hwp+zip 이라 위 mime 분기 어디에도 안 걸리고 확장자로 내려온다.
  // hwp 만 있고 hwpx 가 빠져 있어 한글 신형 문서만 회색 generic 아이콘이 되던 것을 맞춘다 (2026-08-14).
  txt: 'doc', md: 'doc', csv: 'doc', json: 'doc', hwp: 'doc', hwpx: 'doc',
  zip: 'archive', gz: 'archive', tar: 'archive', rar: 'archive', '7z': 'archive',
};

function kindOf(mimeType: string | null | undefined, name: string): Kind {
  const mime = (mimeType ?? '').toLowerCase();
  if (mime.startsWith('image/')) return 'image';
  if (mime.startsWith('video/')) return 'video';
  if (mime === 'application/pdf' || mime.startsWith('text/')
    || mime.startsWith('application/vnd.openxmlformats-officedocument')
    || mime.startsWith('application/vnd.ms-') || mime === 'application/json') return 'doc';
  if (mime === 'application/zip' || mime === 'application/gzip' || mime === 'application/x-tar') return 'archive';
  const ext = name.split('.').pop()?.toLowerCase() ?? '';
  return EXT_MAP[ext] ?? 'etc';
}

const ICONS: Record<Kind, typeof File> = { image: Image, video: Video, doc: FileText, archive: File, etc: File };

export function AttachmentTypeIcon({ mimeType, name, size = 13 }: {
  mimeType?: string | null;
  name: string;
  size?: number;
}) {
  const kind = kindOf(mimeType, name);
  const Icon = ICONS[kind];
  return (
    <span className={`task-attach-type task-attach-type--${kind}`} aria-hidden="true">
      <Icon size={size} />
    </span>
  );
}
